import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ListLogBatchStatusResponse } from '../../responses/srvlog/list-log-batch-status.response';

@Injectable({
  providedIn: 'root'
})
export class LogBatchStatusService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listLogBatchStatus() : Observable<ListLogBatchStatusResponse> {

    let uri = 'LogBatchStatus/getAll';

    return this.httpClient.get<ListLogBatchStatusResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSrvLog) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
